module.exports = __webpack_public_path__ + "static/header-logo-orange.e647a623.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/header-logo-orange.png
// module id = 1009
// module chunks = 2